module.exports = __webpack_public_path__ + "img/weddings_09_V.fed8030a.webp";